import { whatsappToHtml } from './whatsappToHtml';

const urlRegex = /(https?:\/\/[^\s]+)/gm;
const regexEmoji =
  /((\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])\ufe0f?)/g;

function htmlEncode(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}

export default function parseTextToHtml(text: string, searchQuery?: string) {
  // Preserve the tags used by the legacy message styles. The editor parser
  // intentionally uses semantic <em>/<s> tags for Tiptap.
  const html = whatsappToHtml(text)
    .replace(/<em>/g, '<i>')
    .replace(/<\/em>/g, '</i>')
    .replace(/<s>/g, '<strike>')
    .replace(/<\/s>/g, '</strike>');
  const encodedSearch = searchQuery?.trim()
    ? htmlEncode(searchQuery.trim())
    : '';
  const searchRegex = encodedSearch
    ? new RegExp(
        `(${encodedSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
        'gi',
      )
    : null;
  let insideCode = 0;
  const decorateText = (value: string) => {
    return value
      .replace(searchRegex || /$a/, '<mark class="search-highlight">$1</mark>')
      .replace(regexEmoji, '<em>$1</em>');
  };

  return html
    .split(/(<[^>]+>)/g)
    .map(part => {
      if (part.startsWith('<')) {
        if (/^<(?:code|pre)(?:\s|>)/i.test(part)) insideCode += 1;
        if (/^<\/(?:code|pre)>/i.test(part)) insideCode -= 1;
        return part;
      }

      if (insideCode > 0 || !part) return part;

      return part
        .split(urlRegex)
        .map(value => {
          if (/^https?:\/\//.test(value)) {
            return `<a style="color:inherit;" href="${value}" rel="noreferrer noopener" target="_blank"> ${decorateText(
              value,
            )} </a>`;
          }
          return decorateText(value);
        })
        .join('');
    })
    .join('');
}
